export const FETCH_UPDATE_CUSTOMER_SETTING_REQUEST = 'FETCH_UPDATE_CUSTOMER_SETTING_REQUEST';
export const FETCH_UPDATE_CUSTOMER_SETTING_SUCCESS = 'FETCH_UPDATE_CUSTOMER_SETTING_SUCCESS';
export const FETCH_UPDATE_CUSTOMER_SETTING_FAILURE = 'FETCH_UPDATE_CUSTOMER_SETTING_FAILURE';

export const FETCH_CUSTOMER_NOTIFICATION_SETTING_REQUEST = 'FETCH_CUSTOMER_NOTIFICATION_SETTING_REQUEST';
export const FETCH_CUSTOMER_NOTIFICATION_SETTING_SUCCESS = 'FETCH_CUSTOMER_NOTIFICATION_SETTING_SUCCESS';
export const FETCH_CUSTOMER_NOTIFICATION_SETTING_FAILURE = 'FETCH_CUSTOMER_NOTIFICATION_SETTING_FAILURE';


